import React from 'react'
import './Footer.css'

export default function Footer (parms) {

  return (
    <div className="footer-container">
      <span className="footer-text">Copyright &copy; 2020 Ken Ingram</span>
    </div>
  )
}